// Lesson 1: Menyebutkan Nama dan Sapaan - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 1: Introducing Names and Greetings
export const unit1Lesson1ExtendedWordBank: Word[] = [
    {
        id: 101,
        batak: "ᯀᯉᯃᯒᯉ᯲",
        latin: ["a", "nak", "kon"],
        indonesia: "Nama",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯉᯃ", latin: "nak" },
            { batak_char: "ᯒᯉ᯲", latin: "kon" }
        ]
    },
    {
        id: 102,
        batak: "ᯘᯪᯀᯇ",
        latin: ["si", "a", "pa"],
        indonesia: "Siapa",
        syllable_mapping: [
            { batak_char: "ᯘᯪ", latin: "si" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯇ", latin: "pa" }
        ]
    },
    {
        id: 103,
        batak: "ᯘᯍ",
        latin: ["sa", "ha"],
        indonesia: "Saha (Siapa)",
        syllable_mapping: [
            { batak_char: "ᯘ", latin: "sa" },
            { batak_char: "ᯍ", latin: "ha" }
        ]
    },
    {
        id: 104,
        batak: "ᯀᯍ",
        latin: ["a", "ha"],
        indonesia: "Aha (Siapa)",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯍ", latin: "ha" }
        ]
    },
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 106,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 107,
        batak: "ᯤᯀ",
        latin: ["i", "a"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 108,
        batak: "ᯂᯬᯒᯘ᯲",
        latin: ["ho", "ras"],
        indonesia: "Salam/Halo",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" },
            { batak_char: "ᯒᯘ᯲", latin: "ras" }
        ]
    },
    {
        id: 109,
        batak: "ᯘᯪ",
        latin: ["si"],
        indonesia: "si (penanda nama)",
        syllable_mapping: [
            { batak_char: "ᯘᯪ", latin: "si" }
        ]
    },
    {
        id: 110,
        batak: "ᯒᯤᯉ᯲ᯖᯬ",
        latin: ["rin", "to"],
        indonesia: "Rinto",
        syllable_mapping: [
            { batak_char: "ᯒᯤᯉ᯲", latin: "rin" },
            { batak_char: "ᯖᯬ", latin: "to" }
        ]
    },
    {
        id: 111,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "do (penghubung)",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 112,
        batak: "ᯀᯉᯃᯒᯉ᯲ᯔᯮ",
        latin: ["a", "nak", "kon", "mu"],
        indonesia: "Namamu",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯉᯃ", latin: "nak" },
            { batak_char: "ᯒᯉ᯲", latin: "kon" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    {
        id: 113,
        batak: "ᯄᯤᯑᯬ",
        latin: ["ka", "i", "do"],
        indonesia: "Kaido",
        syllable_mapping: [
            { batak_char: "ᯄ", latin: "ka" },
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 998,
        batak: "?",
        latin: ["?"],
        indonesia: "?",
        syllable_mapping: [{ batak_char: "?", latin: "?" }],
    },
    {
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: "", latin: "-" }],
	},
];

// Helper function to create word dictionary
export const createUnit1Lesson1WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
